import ToggleButton from "@/components/Button/ToggleButton";
import { defaultNS, useTranslation } from "@/lib/i18n";
import { memo } from "react";
import type { AttributeCollectionId } from "../../types";

interface CollectionToggleProps {
  /** コレクションID */
  collectionId: AttributeCollectionId;
  /** コレクションインデックス */
  collectionIndex: number;
  /** 有効かどうか */
  enabled: boolean;
  /** 有効/無効が変更されたときのハンドラー */
  onToggle: (enabled: boolean) => void;
}

/**
 * 動的コレクションで、minCount=0の場合に表示されるトグル
 * - checked=true: 入力をスキップする (enabled=false)
 * - checked=false: 入力する (enabled=true)
 */
export const CollectionToggle = memo(
  ({
    collectionId,
    collectionIndex,
    enabled,
    onToggle,
  }: CollectionToggleProps) => {
    const { t } = useTranslation(defaultNS);

    const handleToggleChange = (checked: boolean) => {
      onToggle(!checked);
    };

    const dataAttributes = {
      "data-collection-id": collectionId,
      "data-collection-index": collectionIndex,
      "data-enabled": enabled ? "true" : "false",
    };

    return (
      <div className="mb-4 py-2" {...dataAttributes}>
        <ToggleButton
          id={`collection-toggle-${collectionId}-${collectionIndex}`}
          checked={!enabled}
          onCheckedChange={handleToggleChange}
          label={t("features.formFactory.collectionToggle.skipInput")}
          labelPosition="right"
        />
      </div>
    );
  },
);

CollectionToggle.displayName = "CollectionToggle";
